module.exports = __webpack_public_path__ + "static/caveats-planning-88f78f123e2788b7a486bea1a8353d69.png";